/** @jsx jsx */
/* global __PATH_PREFIX__ */
import { Link } from 'gatsby';
import Navbar from 'react-bootstrap/Navbar';
import { jsx } from 'theme-ui';
import { Brand as styles } from '../Header.styles';

const rootPath = `${__PATH_PREFIX__}/`; // This is set by Gatsby internally.

export default function Brand({
  to = rootPath,
  children,
  inverse = false,
  ...props
}) {
  return (
    <Navbar.Brand as={Link} to={to} {...props} sx={styles}>
      {children}
    </Navbar.Brand>
  );
}
